/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineSystemService() {
        let systemService = {};
        systemService.getProvinces = function () {
            return localStorageCacheHelper.getDataViaGet("/api/SystemService/GetProvinces", localStorageCacheHelper.localStorageKey.provincesKey);
            //return axios.get("/api/SystemService/GetProvinces");
        };
        systemService.getPaymentTypes = function () {
            return axios.get("/api/SystemService/GetPaymentTypes");
        };
        systemService.getDriver = function (driverId) {
            return axios.get("/api/SystemService/GetDriver?driverId=" + driverId);
        };
        systemService.getAllDrivers = function (request) {
            return axios.post("/api/SystemService/GetAllDrivers", request);
        };
        systemService.getAllDepots = function (request) {
            return axios.post("/api/SystemService/GetAllDepots", request);
        };
        systemService.getAllDepotPumpsByDepotId = function (request) {
            return axios.post("/api/SystemService/GetAllDepotPumpsByDepotId", request);
        };
        systemService.getVehicle = function (vehicleId) {
            return axios.get("/api/SystemService/GetVehicle?vehicleId=" + vehicleId);
        };
        systemService.getAllVehicles = function (request) {
            return axios.post("/api/SystemService/GetAllVehicles", request);
        };
        systemService.getVehiclesByDefaultDriverId = function (request) {
            return axios.post("/api/SystemService/GetVehiclesByDefaultDriverId", request);
        };
        systemService.getZones = function (fieldsToFilterBy, request, getFromApi, activeOnly) {
            let localStorageKey = localStorageCacheHelper.localStorageKey.zonesKey;
            if(!activeOnly){
                localStorageKey = localStorageCacheHelper.localStorageKey.zonesInactiveKey;
            }
            //return axios.post("/api/SystemService/GetZones", request);
            return localStorageCacheHelper.getDataPost("/api/SystemService/GetZones", fieldsToFilterBy, request, localStorageKey, getFromApi);
        };
        systemService.getShippingAreas = function (fieldsToFilterBy, request, getFromApi, activeOnly) {
            //return axios.post("/api/SystemService/GetShippingAreas", request);
            let localStorageKey = localStorageCacheHelper.localStorageKey.shippingAreasKey;
            if(!activeOnly){
                localStorageKey = localStorageCacheHelper.localStorageKey.shippingAreasInactiveKey;
            }
            return localStorageCacheHelper.getDataPost("/api/SystemService/GetShippingAreas", fieldsToFilterBy, request, localStorageKey, getFromApi);
        };
        systemService.addOrUpdateDriver = function (request) {
            return axios.post("/api/SystemService/AddOrUpdateDriver", request);
        };
        systemService.addOrUpdateDepot = function (request) {
            return axios.post("/api/SystemService/AddOrUpdateDepot", request);
        };
        systemService.addOrUpdateDepotPump = function (request) {
            return axios.post("/api/SystemService/AddOrUpdateDepotPump", request);
        };
        systemService.addOrUpdateVehicle = function (request) {
            return axios.post("/api/SystemService/AddOrUpdateVehicle", request);
        };
        systemService.addOrUpdateZone = function (request) {
            return axios.post("/api/SystemService/AddOrUpdateZone", request);
        };
        systemService.addOrUpdateShippingArea = function (request) {
            return axios.post("/api/SystemService/AddOrUpdateShippingArea", request);
        };
        systemService.markDepotAsActiveOrInactive = function (request) {
            return axios.post("/api/SystemService/MarkDepotAsActiveOrInactive", request);
        };
        systemService.markDepotPumpAsActiveOrInactive = function (request) {
            return axios.post("/api/SystemService/MarkDepotPumpAsActiveOrInactive", request);
        };
        systemService.markVehicleAsActiveOrInactive = function (request) {
            return axios.post("/api/SystemService/MarkVehicleAsActiveOrInactive", request);
        };
        systemService.markDriverAsActiveOrInactive = function (request) {
            return axios.post("/api/SystemService/MarkDriverAsActiveOrInactive", request);
        };
        systemService.markZoneAsActiveOrInactive = function (request) {
            return axios.post("/api/SystemService/MarkZoneAsActiveOrInactive", request);
        };
        systemService.markShippingAreaAsActiveOrInactive = function (request) {
            return axios.post("/api/SystemService/MarkShippingAreaAsActiveOrInactive", request);
        };
        systemService.getVehicleCompartmentProducts = function (vehicleId) {
            return axios.get("/api/SystemService/GetVehicleCompartmentProducts?vehicleId=" + vehicleId);
        }
        systemService.getTerminals = function (orderTypeId, zoneId) {
            if(orderTypeId === undefined){
                orderTypeId = null;
            }
            if(zoneId === undefined){
                zoneId = null;
            }
            return axios.get("/api/SystemService/GetTerminals?orderTypeId=" + orderTypeId + "&zoneId=" + zoneId);
        };

        // DepotAttendant methods
        systemService.getDepotAttendantByDepotAttendantId = function (depotAttendantId) {
            return axios.get("/api/SystemService/GetDepotAttendantByDepotAttendantId?depotAttendantId=" + depotAttendantId);
        };

        systemService.getDepotAttendantByAttendantNumber = function (attendantNumber) {
            return axios.get("/api/SystemService/GetDepotAttendantByAttendantNumber?attendantNumber=" + attendantNumber);
        };

        systemService.getDepotAttendants = function (depotId, isActive, searchQuery) {
            let url = "/api/SystemService/GetDepotAttendants?";
            let params = [];
            
            if (depotId !== undefined && depotId !== null) {
                params.push("depotId=" + depotId);
            }
            if (isActive !== undefined) {
                params.push("isActive=" + isActive);
            }
            if (searchQuery !== undefined && searchQuery !== null) {
                params.push("searchQuery=" + encodeURIComponent(searchQuery));
            }
            
            url += params.join("&");
            return axios.get(url);
        };

        systemService.addOrUpdateDepotAttendant = function (request) {
            return axios.post("/api/SystemService/AddOrUpdateDepotAttendant", request);
        };

        systemService.markDepotAttendantAsActiveOrInactive = function (request) {
            return axios.post("/api/SystemService/MarkDepotAttendantAsActiveOrInactive", request);
        };

        systemService.transferDepotAttendantToDepot = function (request) {
            return axios.post("/api/SystemService/TransferDepotAttendantToDepot", request);
        };

        // Audit methods
        systemService.getAuditByOrderId = function (orderId, searchTerm) {
            let url = "/api/SystemService/GetAuditByOrderId?orderId=" + orderId;
            if (searchTerm !== undefined && searchTerm !== null && searchTerm !== "") {
                url += "&searchTerm=" + encodeURIComponent(searchTerm);
            }
            return axios.get(url);
        };

        systemService.getAuditByCompanyId = function (companyId, searchTerm) {
            let url = "/api/SystemService/GetAuditByCompanyId?companyId=" + companyId;
            if (searchTerm !== undefined && searchTerm !== null && searchTerm !== "") {
                url += "&searchTerm=" + encodeURIComponent(searchTerm);
            }
            return axios.get(url);
        };

        systemService.getCompanyOrderAuditsByCompanyId = function (companyId, searchTerm) {
            let url = "/api/SystemService/GetCompanyOrderAuditsByCompanyId?companyId=" + companyId;
            if (searchTerm !== undefined && searchTerm !== null && searchTerm !== "") {
                url += "&searchTerm=" + encodeURIComponent(searchTerm);
            }
            return axios.get(url);
        };

        systemService.addAudit = function (request) {
            return axios.post("/api/SystemService/AddAudit", request);
        };

        systemService.deleteAudit = function (auditId) {
            return axios.delete("/api/SystemService/DeleteAudit?auditId=" + auditId);
        };

        return systemService;
    }
    //define globally if it doesn't already exist
    if (typeof (systemService) === "undefined") {
        window.systemService = defineSystemService();
    } else {
        console.log("systemService already defined.");
    }
})(window);